export default __webpack_public_path__ + "static/media/Gr_Quantity.4a86ebdc.svg";